<template>
  <div>
    <CContainer class="mb-4">
      <CRow>
        <CCol md="3">
          <CButton class="w-100" color="success" @click="() => { modalVisible.insert = true }">
            <div class="button-text">
              <CIcon name="cil-plus" />
              <span>New</span>
            </div>
          </CButton>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Loader -->
    <CContainer class="d-flex justify-content-center" v-if="isLoad">
      <CSpinner color="primary" size="lg"/>
    </CContainer>
    <CContainer v-else>
      <CRow v-if="colors.length">
        <CCol 
          :sm="3" 
          v-for="color in colors" 
          :key="color.id"
        >
          <CCard>
            <CCardBody>
              <CCardTitle>{{ color.color_name }}</CCardTitle>
              <p class="card-sub-title">{{ color.chinese_name || '-'}}</p>
            </CCardBody>
            <CCardFooter>
              <CButton class="mr-2" color="primary" variant="ghost" @click="handleEdit(color)">
                <div class="button-text">
                  <CIcon name="cil-pencil" />
                  <span>Edit</span>
                </div>
              </CButton>
              <CButton color="danger" variant="ghost" @click="() => { 
                modalVisible.delete = true 
                id = color.id
              }">
                <div class="button-text">
                  <CIcon name="cil-trash" />
                  <span>Delete</span>
                </div>
              </CButton>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal
      :show.sync="modalVisible.insert"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CRow>
        <CCol md="12">
          <CForm class="w-100">
            <div class="mb-3">
              <CInput
                label="Color Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the color name. (avoid using '-' or '/')"
                v-model="colorName"
                :is-valid="colorNameValidator"
              />
              <CInput
                label="Color Chinese Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide a valid color name. (avoid using '-' or '/')"
                v-model="chineseName"
                :is-valid="colorChineseNameValidator"
              />
            </div>
          </CForm>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Insert Color</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleInsert" color="primary" :disabled="!isValidatePass">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      :show.sync="modalVisible.edit"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CRow>
        <CCol md="12">
          <CForm class="w-100">
            <div class="mb-3">
              <CInput
                label="Color Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the color name. (avoid using '-' or '/')"
                v-model="colorName"
                :is-valid="colorNameValidator"
              />
              <CInput
                label="Color Chinese Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide a valid color name. (avoid using '-' or '/')"
                v-model="chineseName"
                :is-valid="colorChineseNameValidator"
              />
            </div>
          </CForm>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Edit Color</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleSave" color="primary" :disabled="!isValidatePass">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      title="Modal title"
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="modalVisible.delete"
    >
      Are you sure you want to delete this item ?
      <div class="mt-2">
        <mark><b>WARNING:</b> PRODUCT that used this COLOR will also be <b>DELETED.</b></mark>
      </div>
      <template #header>
        <h5 class="modal-title">Delete Color</h5>
        <CButtonClose @click="dismissModal" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="handleDelete(id)" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { 
  COLOR_CREATE,
  COLOR_UPDATE,
  COLOR_DELETE,
  COLOR_GET, 
} from '../../../constants/api'

import axios from 'axios'

export default {
  data () {
    return {
      id: '',
      colorName: '',
      chineseName: '',
      colors: [],
      validatePass: {
        colorName: false,
        chineseName: false
      },
      modalVisible: {
        edit: false,
        insert: false,
        delete: false,
      },
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },

  computed: {
    isValidatePass () {
      return !Object.values(this.validatePass).includes(false)
    }
  },

  beforeMount () {
    this.fetchColor()
  },

  methods: {
    fetchColor () {
      this.isLoad = true

      axios.get(COLOR_GET, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(res => {
          this.colors = res.data.data
          this.isLoad = false
          this.dismissModal()
        })
    }, 

    handleEdit (color) {
      const { id, color_name, chinese_name } = color

      this.id = id
      this.colorName = color_name
      this.chineseName = chinese_name

      this.modalVisible.edit = true
    },

    handleInsert () {
      const payload = {
        name: this.colorName,
        chinese_name: this.chineseName
      }
      axios.post(COLOR_CREATE, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchColor())
    },

    handleDelete (id) {
      axios.delete(`${COLOR_DELETE}${id}`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchColor())
    },

    handleSave () {
      const payload = {
        name: this.colorName,
        chinese_name: this.chineseName
      }
      axios.put(`${COLOR_UPDATE}${this.id}`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchColor())
    },

    dismissModal () {
      this.id = ''
      this.colorName = ''
      this.chineseName = ''
      this.modalVisible.edit = false
      this.modalVisible.delete = false
      this.modalVisible.insert = false
    },

    // validator
    colorNameValidator (val) {
      if (val.length > 0 && !/[-\/]/.test(val)) {
        this.validatePass.colorName = true
        return true
      } else {
        this.validatePass.colorName = false
        return false
      }
    },
    colorChineseNameValidator (val) {
      if (val?.length > 0 && /[-\/]/.test(val)) {
        this.validatePass.chineseName = false
        return false
      }
      this.validatePass.chineseName = true
      return true
    },
  }  
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
  .card-sub-title {
    font-size: 18px;
  }
</style>